import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UIkit'

export const useInfoCardStyles = makeStyles(theme => ({
  infoContainer: {
    overflowY: 'auto',
    height: '100vh',
    maxHeight: 310,
    flexWrap: 'nowrap'
  },
  descr: {
    color: GRAY_COLORS[600],
    fontSize: 14
  },
  infoDescr: {
    color: GRAY_COLORS[900],
    fontSize: 14,
    wordBreak: 'break-word'
  }
}))
